import type { HelpFile } from '../../types/help'
import { ResponseFiltersEditorTestIds } from '../../../testids/ResponseFiltersEditorTestIds'

export const responseFiltersEditorHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [ResponseFiltersEditorTestIds.responseFilters]:
      'Post-fetch AND-filter — keep only items where every (field = value) match. Each row is one (field, value) pair compared as strings against the source record.',
    [ResponseFiltersEditorTestIds.btnAddResponseFilter]:
      'Add another field-value pair to the response filter. All pairs must match for an item to be kept.',
  },
}
